export type PermissionValue =
	| 'invite_users'
	| 'manage_roles'
	| 'case_admin'
	| 'case_management'
	| 'read_access'
	| 'delete_users';

export type Permission = {
	id: number;
	name: string;
	value: PermissionValue;
	is_allowed: boolean;
};

export function toAllowedSet(permissions: Permission[]) {
	const s = new Set<PermissionValue>();
	for (const p of permissions) if (p.is_allowed) s.add(p.value);
	return s;
}

export function hasPermission(
	allowed: Set<PermissionValue>,
	p: PermissionValue
) {
	return allowed.has(p);
}

// opcional: expresiones sencillas
export function can(
	allowed: Set<PermissionValue>,
	check:
		| PermissionValue
		| {
				allOf?: PermissionValue[];
				anyOf?: PermissionValue[];
				not?: PermissionValue[];
		  }
) {
	if (typeof check === 'string') return allowed.has(check);
	const { allOf, anyOf, not } = check;
	if (allOf && !allOf.every((x) => allowed.has(x))) return false;
	if (anyOf && !anyOf.some((x) => allowed.has(x))) return false;
	if (not && not.some((x) => allowed.has(x))) return false;
	return Boolean(allOf?.length || anyOf?.length) || false;
}
